import React from 'react';
import { useState, useEffect } from 'react';
import './classes/SuccessStories.css';
import { configData } from "../config";

const SuccessStories = ({page}) => {
const app_url = configData.APP_URL;
const [content, setContent] = useState([]);

useEffect(() => {
    //     setContent([
    // { name: 'Raymond Haija', title: 'NFL & CFL Agent', img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw' },
    // { name: 'Donovan Phillips', title: 'The Champions Agency Founder', img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw' }
    // ]);
    if(page?.nid) {
getsuccessstories(page.nid);
}
}, [page]);
const getsuccessstories = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/getsuccessstories', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(data.data.result);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
    // A picture that is missing on the server: show the "not available" image instead of a
    // broken one (a broken picture also stretches to the full height of the page)
    const placeholderImg = configData.DRUPAL_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
    const showPlaceholder = (event) => {
        if (event.currentTarget.src !== placeholderImg) {
          event.currentTarget.src = placeholderImg;
        }
    };
    // As on the live site, the block is left out when there is nothing to list
    if (!content.length) return null;
    return (
        <div className="course-success-box">
            <h2 className="success-title">Success Stories</h2>
                <ul className="success-box-list">
                    {/* The live site's list stops at 50 stories */}
                    {content.slice(0, 50).map((story, idx) => (<>
                        <li key={idx} className="success-profile">
                            <img src={story.img} alt={story.name} className="success-img" onError={showPlaceholder} />
                            <div>
                                <strong className="success-name">{story.name}</strong>
                               
                                <p className="success-text"  dangerouslySetInnerHTML={{
                    __html:story.title
                }}></p>
                            </div>
                        </li>
                        <div className="success-story-sepline">&nbsp;</div>
                    </>))}
                </ul>
            {/* </div> */}
        </div>
    );
};
export default SuccessStories;